var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"left",attrs:{"to":{name: _vm.$routeResolver('routes.chat-status')}}},[_c('img',{attrs:{"src":_vm.$mobileCdn('images/icons/perm-phone-msg.svg'),"alt":"Chat","width":"18px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }